import { EntityLocationDTO } from '@user/store/map/typings'

// SH-1437: a pin/address has no real Sales Center entity behind it when this is
// true — covers standalone knock-status pins (entityId 0) and pins with no entity
// at all (entityId null, e.g. a brand-new PestPac pin). Kept as a single shared
// predicate so the various knock-status flows can't drift out of sync on what
// counts as "no entity" the way useHistoryData and useHandlers previously did.
export function hasNoBackingEntity(
  pin: Pick<EntityLocationDTO, 'entityId'> | null | undefined,
): boolean {
  return pin != null && (pin.entityId === 0 || pin.entityId == null)
}
